import { LoginDataPropsType } from "Context/types/LoginDataPropsType";

import { AdminTypes } from "Types/enums";

export const DefaultLogin: LoginDataPropsType = {
  type                    : AdminTypes.CLIENT,
  isRoot                  : false,
  username                : "",
  firstName               : "",
  middleName              : "",
  lastName                : "",
  language                : "",
  forceChangePassword     : false,
  lastLoginCity           : "",
  lastLoginCountry        : "",
  clientCurrencyCode      : "USD",
  clientLanguages         : ["en"],
  clientEmailSender       : "",
  clientCaptchaEnabled    : false,
  clientOtpEnabled        : false,
  canExport               : false,
  updateImportantFields   : [],
  ip                      : "",
  token                   : "",
  permissions             : [],
  profilePhoto            : "",
  device                  : {
    browser     : "",
    device      : "",
    isMobile    : false
  },
  location                : {
    city        : "",
    country     : ""
  },
  client                  : {
    id          : "",
    name        : "",
    slug        : "",
    siteName    : "",
    domain      : "",
    timezone    : ""
  }
};